export default __webpack_public_path__ + "static/media/visas.dfcb4019.webp";